import { takeLatest, put } from "redux-saga/effects";
import { SAVE_SELECTED_TAB } from "../ActionTypes/index";
import { setSelectedTab } from "./actionCreators";

function* handleSaveSelectedTab(action) {
  try {
    yield put(setSelectedTab(action.payload));

    // Optional: persist or API call
    // localStorage.setItem("selectedTab", action.payload);
  } catch (err) {
      }
}

export default function* tabSaga() {
  yield takeLatest(SAVE_SELECTED_TAB, handleSaveSelectedTab);
}
